import "./styles.scss";

/**
 * Render a Footer element with Copyright
 * @category Components
 * @component
 * @returns { React.Component } A React component
 */

function Footer() {
    return (
        <footer className="footer">
                Je suis un footer
		</footer>
    );
}

export default Footer;